export const ERROR_TRANSLATIONS: Record<string, string> = {
    'Survey instance is not valid': 'מזהה השאלון אינו תקין.',
    'Survey instance not active': 'השאלון אינו פעיל כעת.',
    'Invalid email domain': 'כתובת האימייל אינה שייכת לארגון המורשה עבור שאלון זה.',
    'Respondent already exists': 'משתמש עם כתובת אימייל זו כבר רשום לשאלון.',
    'Respondent already filled this survey': 'כבר מילאת את השאלון הזה בעבר.',
    'Missing parameters': 'חסרים פרטים בבקשה.',
    'Organization not found': 'הארגון לא נמצא במערכת.',
    'Invalid token': 'מזהה הגישה אינו תקין או שפג תוקפו.',
    'Respondent not found': 'המשתמש לא נמצא במערכת.',
    'Survey already completed': 'השאלון כבר הושלם בעבר.',
    'Link has been sent to this email': 'קישור כבר נשלח למייל זה. אנא המתינו 5 דקות לפני בקשת קישור חדש.'
};

export function translateError(msg: string | null): string | null {
    if (!msg) return null;

    // Handle dynamic domain error
    if (msg.includes('Survey restricted to emails at')) {
        const domainMatch = msg.match(/at (.*?) domains/);
        const domain = domainMatch ? domainMatch[1] : '';
        return `המערכת מאפשרת רישום עם מיילים מסיומת ${domain} בלבד.`;
    }

    const lowerMsg = msg.toLowerCase();
    for (const [english, hebrew] of Object.entries(ERROR_TRANSLATIONS)) {
        if (lowerMsg.includes(english.toLowerCase())) {
            return hebrew;
        }
    }

    // Sanitize n8n expressions
    if (msg.includes('{{') || msg.includes('$json')) {
        return 'חלה שגיאה בתקשורת עם השרת. אנא נסו שוב או פנו לתמיכה.';
    }

    return msg;
}
